// extracted by mini-css-extract-plugin
export default {"root":"mimic___ButtonGroup_styles_root__-6qRJ"};